/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // fashioncan 05/01/2026
  // update announcement background when hovering over menu items
  const menuHoveredClass = 'meganav--visible';
  const announcementBar = document.querySelector('.template-index .shopify-section-group-group-header announcement-bar');
  const watchElement = document.querySelector('.template-index .header__wrapper');

  if (document.contains(announcementBar)) {
    const announcementObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.target.classList.contains(menuHoveredClass)) {
          announcementBar.classList.toggle('custom-index');
        } else {
          announcementBar.classList.remove('custom-index');
        }
      });
    });

    announcementObserver.observe(watchElement, {attributes: true});
  }

  // fashioncan 11/12/2025
  // display custom text message upon switching product size variant
  const productVariantSelector = document.querySelector('.selector-wrapper--size input[name*="ize-"] + label');
  const productVariantSelectedTarget = '.product__price__wrap form[action="/cart/add"] input[name="id"]';
  const productVariantSelectedId = document.querySelector(productVariantSelectedTarget);

  if (document.contains(productVariantSelector)) {
    // wait for the variants to be loaded by the theme
    waitForElementToExist(productVariantSelectedTarget).then(element => {
      // show the message based upon the initially selected size
      let selectedVariantSize = document.querySelector('.selector-wrapper--size [data-variant-buttons] input[data-option-value-id]:checked').value;
      toggleVariantMessage(selectedVariantSize);

      // when new variant is selected
      productVariantSelectedId.addEventListener('change', processVariantSelectMessageEvent);
    });
  }

  function processVariantSelectMessageEvent(event) {
    const thisVariantId = parseInt(event.target.value);
    const thisVariantData = productVariantData.variants.find(variant => variant.id === thisVariantId);
    const thisVariantSize = thisVariantData.option1;

    toggleVariantMessage(thisVariantSize);
  }

  function toggleVariantMessage(size) {
    if (size) {
      document.querySelectorAll('.product-variant-text.product-variant-sizes [data-label]').forEach(function(element) {
        element.style.display = 'none';
      });

      document.querySelector(`.product-variant-text.product-variant-sizes [data-label="${size}"]`).style.display = 'flex';
      document.querySelector('.product-variant-text.product-variant-sizes').style.display = 'flex';
    }
  }

  function waitForElementToExist(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          observer.disconnect();
          resolve(document.querySelector(selector));
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();